import { useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { cn } from 'src/shared/utils/cn'

const InstantMatchButton = ({
  text,
  className,
  onClick,
}: {
  text: string
  className?: string
  onClick?: () => void
}) => {
  const navigate = useNavigate()

  const onInstantMatch = () => {
    navigate(paths.marketplace.instantMatch.getHref())
  }

  return (
    <button
      className={cn(
        'w-max rounded-full bg-secondaryInverse px-6 py-2 text-sm font-semibold shadow transition hover:bg-secondaryInverse/90 md:px-9 md:py-3 md:text-base',
        className,
      )}
      onClick={onClick ? onClick : onInstantMatch}
    >
      {text}
    </button>
  )
}

export default InstantMatchButton
